import { initLenis } from './lenis';
import { initGsap } from './gsap';
import { initSetHeaderHeight } from './setHeaderHeight';
import { initModal } from './modal';

// PC判定用関数
function isPC() {
  const userAgent = window.navigator.userAgent.toLowerCase();

  // スマホ・タブレットを判定
  const isMobile = /iphone|ipod|android.*mobile|windows phone|blackberry/.test(userAgent);
  const isTablet = /ipad|android(?!.*mobile)|tablet/.test(userAgent);

  // PCブラウザのみtrueを返す
  return !isMobile && !isTablet;
}

export default async function utilitiesAll() {
  if (isPC()) {
    initLenis();
  }
  initGsap();
  initSetHeaderHeight();
  initModal();
}
